import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Cacheable } from "ts-cacheable";

import { environment } from "@environments/environment";

import { ParamsService } from "@shared/Services/params.service";

import { Dropdown } from "@salud/shared/Types/dropdown.enum";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { PorfolioDistribution } from "../Types/Interfaces/portfolio-distribution.interface";

const { enlineaBackendUrl } = environment;

@Injectable()
export class PorfolioDistributionRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getMonedas(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/insurances/Common/Dropdown/${Dropdown.monedaSeguro}`);
  }

  @Cacheable()
  public getPorfolioDistributions(currencyCode: string): Observable<PorfolioDistribution[]> {
    const params = this.paramsService.mapRequestParams({ currencyCode });
    return this.http.get<PorfolioDistribution[]>(
      `${enlineaBackendUrl}/api/insurances/Indicators/PortfolioDistributionChartByProducts`,
      { params }
    );
  }
}
